<template>
  <svg
    style="isolation:isolate"
    viewBox="0 0 200 200"
    :width="size"
    :height="size"
  >
    <path :fill="this.$store.getters.getTheme.fore" d=" M 92.5 175.634 L 92.5 199 L 107.5 199 L 107.5 175.634 C 145.931 171.862 176 139.415 176 100 C 176 60.585 145.931 28.138 107.5 24.366 L 107.5 1 L 92.5 1 L 92.5 24.366 C 54.069 28.138 24 60.585 24 100 L 24 100 C 24 139.415 54.069 171.862 92.5 175.634 Z  M 92.5 160.545 L 92.5 39.455 C 86.928 40.141 81.465 41.597 76.27 43.79 C 69.03 46.86 62.44 51.31 56.88 56.88 C 51.31 62.44 46.86 69.03 43.79 76.27 C 40.62 83.78 38.99 91.85 39 100 L 39 100 C 38.99 108.15 40.62 116.22 43.79 123.73 C 46.86 130.97 51.31 137.56 56.88 143.12 C 62.44 148.69 69.03 153.14 76.27 156.21 C 81.465 158.403 86.928 159.859 92.5 160.545 Z  M 107.5 39.455 L 107.5 160.545 C 113.072 159.859 118.535 158.403 123.73 156.21 C 130.97 153.14 137.56 148.69 143.12 143.12 C 148.69 137.56 153.14 130.97 156.21 123.73 C 159.38 116.22 161.01 108.15 161 100 C 161.01 91.85 159.38 83.78 156.21 76.27 C 153.14 69.03 148.69 62.44 143.12 56.88 C 137.56 51.31 130.97 46.86 123.73 43.79 C 118.535 41.597 113.072 40.141 107.5 39.455 Z " fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  name: 'PartOfSpirit',
  props: ['size']
}
</script>
